import { getLocale } from "../runtime";

const sv_nlcountry = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Nederländerna`
};

const nlcountry = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_nlcountry(inputs)
	return "nlCountry";
};

export { nlcountry as "nlCountry" };